import request from '@/CommonDP/utils/request';

export default {
  checkDrawing(params) {
    return request
      .get(`/chk-point/dictTree/${params}/0`)
      .then((res) => res);
  },
  designStandard(params) {
    return request
      .post('/SpaceDesignStandard/queryByRoomID', params)
      .then((res) => res);
  },
  queryByKeyWord(params) {
    return request
      .post('/SpaceDesignStandard/queryByKeyWord', params)
      .then((res) => res);
  },
  getDic(params) {
    return request.get(`/common/dict/${params}`).then((res) => res);
  },
  getAlldata() {
    return request.get('/chk-point/getVersionTree').then((res) => res);
  }
};
